define('responsive-gameday-calendar/responsive-gameday-calendar',['require','./src/js/GamedayCalendar'],function(require) {
    return require('./src/js/GamedayCalendar');
});
